import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "order-complete" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Thank you for your order!", -1)
const _hoisted_3 = {
  key: 0,
  id: "order-complete-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "thank-you" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "You will receive an email with your order information and a link to download your tickets.")
  ])
], -1)
const _hoisted_5 = { id: "order-info" }
const _hoisted_6 = { id: "customer-info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Billing Information", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "We can't wait to see you!")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Doors open at 6:00"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Dinner at 7:00"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Drama at 8:00")
], -1)
const _hoisted_15 = { id: "order-container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Order Summary", -1)
const _hoisted_17 = { id: "products" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "price-qantity" }
const _hoisted_20 = { id: "subtotal" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Order Total:", -1)
const _hoisted_22 = { id: "fee" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Transaction Fee:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SiteHeader),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (Object.keys(_ctx.order).length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.order.customer.firstName) + " " + _toDisplayString(_ctx.order.customer.lastName), 1),
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.line1), 1),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.line2), 1),
                  (_ctx.order.customer.address.line2)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_10))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.city) + ", " + _toDisplayString(_ctx.order.customer.address.stateOrProvince) + " " + _toDisplayString(_ctx.order.customer.address.postalCode), 1),
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.order.customer.email), 1),
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(_ctx.order.customer.phone), 1)
                ]),
                _hoisted_13,
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.products, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "product",
                      key: product._id
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(product.name) + ", " + _toDisplayString(_ctx.formatDate(product.eventDate)), 1),
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("strong", null, _toDisplayString(product.quantity), 1),
                        _createTextVNode(" x $" + _toDisplayString(Number(product.price.$numberDecimal)), 1)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" $" + _toDisplayString(Number(_ctx.order.orderTotal.$numberDecimal).toFixed(2)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(" $" + _toDisplayString(Number(((Number(_ctx.order.orderTotal.$numberDecimal) + .30) / (1 - .029)) - Number(_ctx.order.orderTotal.$numberDecimal)).toFixed(2)), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}